import { ActionReducerMap } from "@ngrx/store";
import { LastplayersState } from "./lastplayers/lastplayers.state";
import { RanklistState } from "./ranklist/ranklist.state";
import { RoomchampionsState } from "./roomchampions/roomchampions.state";
import * as fromRoomchampions from './roomchampions/roomchampions.reducer';
import * as fromBranchChampions from './branchchampions/branchchampions.reducer';
import * as fromLastplayers from './lastplayers/lastplayers.reducer';
import * as fromRanklist from './ranklist/ranklist.reducer';
import * as fromRunningActions from './runningaction/running-action.reducer';
import { RoomchampionsEffects } from "./roomchampions/roomchampions.effects";
import { LastplayerEffects } from "./lastplayers/lastplayers.effects";
import { RanklistEffects } from "./ranklist/ranklist.effects";
import { RunningActionState } from "./runningaction/running-action.state";
import { BranchChampionsState } from "./branchchampions/branchchampions.state";
import { BranchChampionsEffects } from "./branchchampions/branchchampions.effects";


export interface AppState {
    roomchampions: RoomchampionsState;
    branchChampions: BranchChampionsState;
    lastplayers: LastplayersState;
    ranklist: RanklistState;
    runningActions: RunningActionState;
}

export const reducers: ActionReducerMap<AppState> = {
    roomchampions: fromRoomchampions.reducer,
    branchChampions: fromBranchChampions.reducer,
    lastplayers: fromLastplayers.reducer,
    ranklist: fromRanklist.reducer,
    runningActions: fromRunningActions.reducer,
};

export const effects = [
    RoomchampionsEffects,
    BranchChampionsEffects,
    LastplayerEffects,
    RanklistEffects
];
